import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

// 借助 createSlice 创建 reducer、action
const PageSlice = createSlice({
    name: 'page',
    initialState: {
        value: {},
    },
    reducers: {
        setPage: (state, action: PayloadAction<any>) => {
            state.value = action.payload;
        },
    },
});

// Action Creator 用于执行返回描述如何更新 state 的 Action
export const { setPage } = PageSlice.actions;

// Selector，作为 useSelector 读取数据的函数参数
export const pageSelector = (state: RootState) => state.page.value;

// Reducer，真正执行修改 state 的纯函数
export default PageSlice.reducer;
